if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      /* AYAQ */
      var variantInput = document.getElementById("vid");
      var vid = variantInput.value;
      var vtype = variantInput.getAttribute("vendor");
      if (!!vtype && vtype=="---ayaqch"){// obsolète
        var vidToCH = aP["toCH"][vid];
        variantInput.value = vidToCH;
      }
      /********/
      
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

    var addWorkDays = function (startDate, days) {
        if(isNaN(days)) {
            console.log("Value provided for \"days\" was not a number");
            return
        }
        if(!(startDate instanceof Date)) {
            console.log("Value provided for \"startDate\" was not a Date object");
            return
        }
        // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
        var dow = startDate.getDay();
        var daysToAdd = parseInt(days);
        // If the current day is Sunday add one day
        if (dow == 0)
            daysToAdd++;
        // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
        if (dow + daysToAdd >= 6) {
            //Subtract days in current working week from work days
            var remainingWorkDays = daysToAdd - (5 - dow);
            //Add current working week's weekend
            daysToAdd += 2;
            if (remainingWorkDays > 5) {
                //Add two days for each working week by calculating how many weeks are included
                daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
                //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
                if (remainingWorkDays % 5 == 0)
                    daysToAdd -= 2;
            }
        }
        startDate.setDate(startDate.getDate() + daysToAdd);
        return startDate;
    };

    var getDeliveryDate = function(){
      var today = new Date();
      var deliveryDate = addWorkDays(today, 3); // Tue Nov 29 2016 00:00:00 GMT+0000 (GMT Standard Time)
      var dd = String(deliveryDate. getDate()). padStart(2, '0');
      var mm = String(deliveryDate. getMonth() + 1). padStart(2, '0'); //January is 0!
      var yyyy = deliveryDate. getFullYear();
      var deliveryDate = dd + '/' + mm + '/' + yyyy;
      return deliveryDate;
    };

    var displaySticky = function(){
      if (!variantSoldOut){
        posScroll = $(document).scrollTop();
        if(posScroll >=200){
          $('.stickyatc').fadeIn(600);
          showChat(false);
        }
        else{
          showChat(true);
          $('.stickyatc').fadeOut(600);
        }
      }
    };

  document.addEventListener("DOMContentLoaded", function(event) {
    document.querySelectorAll('.accordion-button').forEach(button => {
      button.addEventListener('click', function() {
        const accordionContent = this.nextElementSibling;
        const icon = this.querySelector('.fas.fa-angle-down, .fas.fa-angle-up'); // Sélectionne uniquement l'icône angle
    
        this.classList.toggle('active');
    
        if (accordionContent.style.maxHeight) {
          accordionContent.style.maxHeight = null;
          icon.classList.remove('fa-angle-up');
          icon.classList.add('fa-angle-down');
        } else {
          accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
          icon.classList.remove('fa-angle-down');
          icon.classList.add('fa-angle-up');
        }
      });
    });

    $("#linksize").click(function() {
      $("html, body").animate( { scrollTop: $( "#ongletsize" ).offset().top }, 1000);
      $( "#ongletsize" ).trigger( "click" );
    });
    
    var deliveryDate = getDeliveryDate();

    if (!prevente){
      $(".deliveryDateSpan").html(deliveryDate);
    }

    $('#moredetails').click(function(){
      $('#details')[0].scrollIntoView({
        behavior: 'smooth'
      });
    });
      
    $("#addToCartSticky").addClass($("#addToCart").attr("class"));
    $('#addToCartSticky').click(function(e){
      $('#addToCart').trigger('click');
      e.preventDefault();
    });
    $(window).scroll(function(){
        displaySticky();
    });


});


